import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setCountryFrom,
  setCountryTo,
  setAmount,
} from "../../store/slices/formSlice";
import apiGetMethod from "../../utils/api";
import Form from "../../components/Form";
import AboutCard from "./components/AboutCard";
import WhyChooseMoney from "./components/WhyChooseMoney";
import ExpertInsights from "./components/ExpertInsights";
import GetMoreValue from "./components/GetMoreValue";
import InstantRates from "./components/InstantRates";
import AboutSection from "./components/AboutSection";
import Countries from "./components/Countries";
import Accordion from "../../components/Accordion";
import { useNavigate } from "react-router-dom";
import Homepage_Data from "../../utils/HomepageData";
import { pushToDataLayer } from "../../utils/gtm";
import { InFeedAd,DisplayAdHorizontal,DisplayAdVertical } from "../../components/AdComponents";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formData = useSelector((state) => state.form);
  const [showCollapsedCard, setShowCollapsedCard] = useState(false);
  const [showExchange, setShowExchange] = useState(false);

  useEffect(() => {
    pushToDataLayer("app_open", {
      source: "organic",
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setAmount(value)); // Update amount in the Redux store
  };

  const handleCountryChange = (country, name) => {
    if (name === "countryFrom") {
      dispatch(setCountryFrom(country));
      localStorage.setItem('countryFrom', JSON.stringify(country));
    } else if (name === "countryTo") {
      localStorage.setItem('countryTo', JSON.stringify(country));
      dispatch(setCountryTo(country));
    }
  };

  const handleCollapse = () => {
    if (showExchange) setShowCollapsedCard(!showCollapsedCard);
    return;
  };

  const onSubmit = () => {
    const { amount, amountType, countryFrom, countryTo } = formData;
    const currencyFromParams = countryFrom.currencies[0]?.code;
    const currencyToParams = countryTo.currencies[0]?.code;
    pushToDataLayer("rate_converted", {
      country_from: countryFrom,
      country_to: countryTo,
      from_currency: currencyFromParams,
      to_currency: currencyToParams,
      amount,
    });
    if (
      countryFrom &&
      countryTo &&
      amount &&
      amountType &&
      currencyFromParams &&
      currencyToParams
    ) {
      navigate(
        `/search/send-money-${countryFrom.code.toLowerCase()}-to-${countryTo.code.toLowerCase()}`
      );
      setShowExchange(true);
      setShowCollapsedCard(true);
    } else {
      alert("All fields are mandatory");
    }
  };

  const fetchData = async () => {
    const { amount, amountType, countryFrom, countryTo } = formData;
    // Add checks for null/undefined values before accessing properties
    if (countryFrom && countryTo) {
      const currencyFromParams =
        countryFrom.currencies && countryFrom.currencies[0]?.code;
      const currencyToParams =
        countryTo.currencies && countryTo.currencies[0]?.code;

      if (currencyFromParams && currencyToParams) {
        await apiGetMethod("search", {
          countryFrom: countryFrom.code,
          countryTo: countryTo.code,
          amount,
          amountType,
          currencyFrom: currencyFromParams,
          currencyTo: currencyToParams,
        });
      } else {
        console.error("Currency data is missing for one or both countries.");
      }
    } else {
      console.error("One or both countries are missing.");
    }
  };

  return (
    <div className="w-full">
      {/* Hero Banner Section */}
      <div
        className="w-full flex flex-col sm:flex-row gap-6 sm:gap-10 bg-heroBanner text-white bg-cover px-5 py-7 pt-[60px] bg-[-95px_60px] md:px-20 md:pt-[6rem] md:bg-center lg:px-32 lg:pt-[6rem] lg:gap-20"
        id="compare-rates-div"
      >
        <div className="flex flex-col gap-3 max-w-6xl mx-auto lg:max-w-[50%] justify-center">
          <h1
            className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold md:leading-[1.2]"
            style={{ lineHeight: 1.2 }}
          >
            {Homepage_Data.heroSection.title}
          </h1>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl lg:leading-relaxed">
            {Homepage_Data.heroSection.desc}
          </p>
        </div>

        {/* Form Section */}
        <div className="max-w-6xl mx-auto w-full lg:max-w-[40%]">
          <Form
            formData={formData}
            onSubmit={onSubmit}
            handleChange={handleChange}
            handleCountryChange={handleCountryChange}
            handleCollapse={handleCollapse}
          />
        </div>
      </div>

      {/* Content Sections */}
      <div className="mx-auto w-full">
        <InFeedAd adSlot="6392138594" />
        <AboutCard />
        <WhyChooseMoney />
        <DisplayAdHorizontal adSlot="5882671009" />
        <ExpertInsights />
        <DisplayAdVertical adSlot="8289951307" />
        <GetMoreValue />
        <InstantRates />
        <AboutSection />
        <Countries />
        <Accordion />
      </div>
    </div>
  );
};

export default HomePage;
